<template>
  <div :class="$style.sectionFeatures">
    <div class="container section">
      <p class="dingbeauty-sub-title">Features</p>
      <h2 class="dingbeauty-title is-dotted">愛美訂，幫您搞 DING</h2>
      <div class="nav-swiper__wrapper">
        <swiper ref="nav-swiper" :options="navSwiperOptions">
          <swiperSlide v-for="(item, index) in featureList" :key="index">
            <div
              :class="{ isActive: currentIndex === index, test: item.title === '商品POS', 'temp-text': item.title !== '商品POS' }"
              class="icon-wrapper"
              @click="slideTo(index)"
              @keydown="slideTo(index)"
            >
              <img :src="item.icon" alt="" />
              <p class="nav-title" v-html="item.title"> </p>
              <div class="underline"></div>
            </div>
          </swiperSlide>
        </swiper>
        <div class="nav-swiper__divider"></div>
      </div>

      <div class="content-swiper__wrapper">
        <img @click="slidePrev" class="left-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowL.svg" alt="" />
        <swiper ref="content-swiper" :options="contentSwiperOptions" @slide-change="contentSlide">
          <swiperSlide v-for="(item, index) in featureList" :key="index">
            <div class="content-img__wrapper">
              <img class="content-img" :src="item.img" alt="" />
            </div>
          </swiperSlide>
        </swiper>
        <img @click="slideNext" class="right-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowR.svg" alt="" />
      </div>

      <p class="mobile-only" style="font-size: 20px; font-weight: 500; margin: 20px 0; text-align: center;">{{ featureList[currentIndex].title }}</p>

      <div class="sub-title">
        <img src="@assets/dingbeauty-images/home/features/icon_web.svg" alt="" />
        <p style="color: #545662;" v-html="featureList[currentIndex].text"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'slick-carousel/slick/slick.css'

export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      currentIndex: 0,
      featureList: [
        {
          title: '專屬官網',
          icon: require('@assets/dingbeauty-images/home/features/icon_reserve.svg'),
          img: require('@assets/dingbeauty-images/home/features/system/system_01.jpg'),
          text: '愛美訂為您打造品牌專屬預約網站，擴大線上渠道的可見性，幫助您吸引更多潛在客戶，提供更多元的預約方式',
        },
        {
          title: '櫃檯管理',
          icon: require('@assets/dingbeauty-images/home/features/icon_counter.svg'),
          img: require('@assets/dingbeauty-images/home/features/system/system_02.jpg'),
          text: '透過直觀的行事曆整合所有預約訂單，清晰呈現不同預約狀態，<br>簡化您的管理流程，讓您輕鬆處理預約，提升管理效能',
        },
        {
          title: '排班管理',
          icon: require('@assets/dingbeauty-images/home/features/icon_arrange.svg'),
          img: require('@assets/dingbeauty-images/home/features/system/system_03.jpg'),
          text: '<span class="special-text">獨家支援24小時全日排班</span> 滿足各種靈活排班需求，讓您輕鬆應對各種排班需求，管理事半功倍',
        },
        {
          title: '療程方案',
          icon: require('@assets/dingbeauty-images/home/features/icon_plan.svg'),
          img: require('@assets/dingbeauty-images/home/features/system/system_04.jpg'),
          text: '愛美訂讓您自由組合適用項目，快速設定各式療程方案，滿足客戶多樣化的美容需求，提升您的業務競爭力',
        },
        {
          title: '儲值點數',
          icon: require('@assets/dingbeauty-images/home/features/icon_stored.svg'),
          img: require('@assets/dingbeauty-images/home/features/system/system_05.jpg'),
          text: '專為會員設計的儲值點數，讓您輕鬆完成設定，還可針對會員客製化儲值點數方案，提供專屬優惠，增強會員消費力',
        },
        {
          title: '商品POS',
          icon: require('@assets/dingbeauty-images/home/features/icon_cart.svg'),
          img: require('@assets/images/home/system_pos@2x.png'),
          text: '唯一整合預約與商品的POS系統，即時完成結帳，實現預約和購物的無縫體驗，大副減少您的花費時間',
        },
      ],

      navSwiperOptions: {
        slidesPerView: 6,
        speed: 1200,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },

          768: {
            slidesPerView: 3,
          },

          992: {
            slidesPerView: 4,
          },
        },
        on: {},
      },

      contentSwiperOptions: {},
    }
  },

  methods: {
    slideTo(index) {
      this.currentIndex = index
      const navSwiper = this.$refs['nav-swiper'].swiper
      const contentSwiper = this.$refs['content-swiper'].swiper
      navSwiper.slideTo(index, 1200)
      contentSwiper.slideTo(index, 1200)
    },

    contentSlide() {
      const activeIndex = this.$refs['content-swiper'].swiper.activeIndex
      this.slideTo(activeIndex)
    },

    slideNext() {
      this.slideTo((this.currentIndex + 1) % 4)
    },

    slidePrev() {
      this.slideTo((this.currentIndex - 1 + 4) % 4)
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #d8b37f;
$color-secondary: #959595;

.sectionFeatures {
  :global {
    .dingbeauty-title {
      margin-bottom: 20px;
    }
    .test {
      position: relative;
      padding-top: 40px;
    }

    .test::after {
      top: 0;
      position: absolute;
      content: 'NEW!';
      left: 50%;
      transform: translateX(-50%);
      color: $color-primary;
    }

    .temp-text {
      position: relative;
      padding-top: 40px;
    }

    .temp-text::after {
      position: absolute;
      content: '';
    }

    p {
      margin-bottom: 0;
    }

    .special-text {
      color: #fff;
      background-color: #c0975d;

      padding: 2px 8px;
      border-radius: 13px;
      line-height: 1.5;
    }

    .nav-swiper__wrapper {
      display: none;
      margin: auto;
      max-width: 1040px;
      margin-bottom: 44px;

      .icon-wrapper {
        color: $color-secondary;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding-bottom: 20px;
        border-bottom: 3px solid transparent;

        img {
          height: 24px;
          transition: all 0.3s;
        }

        &.isActive {
          color: $color-primary;
          border-color: $color-primary;

          img {
            filter: brightness(0) saturate(100%) invert(82%) sepia(28%) saturate(576%) hue-rotate(343deg) brightness(89%) contrast(89%);
          }
        }
      }

      .nav-swiper__divider {
        position: relative;
        top: -2px;
        width: 100%;
        height: 1px;
        background-color: $color-secondary;
      }
    }

    .content-swiper__wrapper {
      display: flex;
      margin: auto;
      max-width: 1072px; // 1040 + 16 + 16

      .content-img__wrapper {
        padding: 16px;
      }

      .content-img {
        box-shadow: 0px 5px 20px #282d4e34;
        border-radius: 10px;
      }
    }

    .sub-title {
      display: flex;
      gap: 12px;
      font-size: 14px;
      justify-content: center;
      max-width: 1040px;
      margin: auto;
      margin-top: 24px;
      padding: 20px;
      border: 1px solid $color-primary;

      img {
        display: none;
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionFeatures {
    :global {
      .mobile-only {
        display: none;
      }

      .dingbeauty-title {
        margin-bottom: 32px;
      }

      .nav-swiper__wrapper {
        display: block;
      }

      .content-swiper__wrapper {
        .left-arrow,
        .right-arrow {
          display: none;
        }
      }

      .sub-title {
        padding: 56px 0;
        font-size: 16px;

        img {
          display: block;
        }
      }

      .special-text {
        padding: 6px 12px;
      }
    }
  }
}
</style>
